import React from 'react';
import { observer } from 'mobx-react';
import FollowButton from './follow-btn';
import APP_OFFICIAL_ACCOUNT from '@tencent/docs-design-resources/mobile/png@3x/app_official_account@3x.png';
import i18n from '@i18next/i18n';
import { IEditingPresentManager, EditingPresentRole } from '@src/slide/application/service/editing-present-manager/core/editing-present-manager.interface';

interface Props {
    editingPresentManager: IEditingPresentManager;
}

/**
 * [编辑态下的远程演示(编辑态跟随)] <跟随共享人> 按钮
 * 仅当参会者脱离跟随时展示，点击恢复跟随
 */
const EditingPresentFollowBtn = observer(({ editingPresentManager }: Props) => {
    // 非参会者不显示
    if (editingPresentManager.role !== EditingPresentRole.audience) return null;

    const visible = !!editingPresentManager.hostSlideId /** 主讲人同步信息不为空 */
        && !editingPresentManager.isPresentFollowing; /** 退出跟随状态 */

    const { localSlideIndex, hostSlideIndex } = editingPresentManager.getSlideIndex();

    return (
        <FollowButton
            visiable={visible}
            shouldShowGuideAnimation
            guideText={i18n.t('跟随共享人')}
            tipText={i18n.t('跟随共享人')}
            imgUrl={editingPresentManager.hostAvatar ?? APP_OFFICIAL_ACCOUNT}
            hideDirection={localSlideIndex === hostSlideIndex}
            directionDegree={localSlideIndex > hostSlideIndex ? 0 : 180}
            onClick={() => editingPresentManager.startPresentFollow()}
        />
    );
});

export default EditingPresentFollowBtn;


